<template>
<!-- eslint-disable -->
<div class="medical-reports-wrapper">
  <div class="column-left">
    <SideNav />
  </div>

  <div class="column-right">
    <TopNavClean />
    <div class="main-container">
      <div class="reports-content">
        <!-- Page Header -->
        <div class="page-header">
          <div class="header-content">
            <div class="title-section">
              <div class="page-icon" :style="{
                  backgroundImage: `linear-gradient(139deg, ${prestador.admin.assets.colors.primary} 0%, ${prestador.admin.assets.colors.secondary} 100%)`
                }">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M3 3v5h5"></path>
                  <path d="M6 17l4-4 4 4 6-6"></path>
                  <path d="M18 7v5h5"></path>
                </svg>
              </div>
              <div>
                <h1 class="page-title">Panel de indicadores</h1>
                <p class="page-subtitle">Análisis y estadísticas de la actividad médica</p>
              </div>
            </div>
            
            <div class="header-actions">
              <button 
                class="download-btn"
                @click="descargarCSV()"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                  <polyline points="7,10 12,15 17,10"></polyline>
                  <line x1="12" y1="15" x2="12" y2="3"></line>
                </svg>
                Descargar Excel
              </button>
            </div>
          </div>
        </div>

        <!-- Main Report Container -->
        <div class="report-container">
          <!-- Filters Section -->
          <div class="filters-section">
            <div class="filters-header">
              <div class="filter-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polygon points="22,3 2,3 10,12.46 10,19 14,21 14,12.46 22,3"></polygon>
                </svg>
              </div>
              <h3>Filtros de Búsqueda</h3>
            </div>

            <div class="filters-grid">
              <!-- Date Range Filter -->
              <div class="filter-group">
                <label class="filter-label">Rango de Fechas</label>
                <div class="date-range-container">
                  <div class="date-input-wrapper">
                    <span class="date-label">Desde:</span>
                    <input
                      v-model="dt_dia"
                      type="date"
                      class="date-input"
                    />
                  </div>
                  <div class="date-separator">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <polyline points="9,18 15,12 9,6"></polyline>
                    </svg>
                  </div>
                  <div class="date-input-wrapper">
                    <span class="date-label">Hasta:</span>
                    <input
                      v-model="dt_dia2"
                      type="date"
                      class="date-input"
                    />
                  </div>
                </div>
              </div>

              <!-- Providers Filter -->
              <div v-show="puede_seleccionar_prestadores" class="filter-group">
                <label class="filter-label">Prestadores</label>
                <div class="multiselect-wrapper">
                  <multiselect
                    v-model="prestadores_seleccionados"
                    :options="prestadores_habilitados"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Seleccionar prestadores"
                    label="nombre"
                    track-by="prestador_id"
                    :preselect-first="true"
                    selectedLabel="Seleccionado"
                    selectLabel="Pulsar para seleccionar"
                    deselectLabel="Pulsar para remover"
                  />
                </div>
              </div>

              <!-- Communes Filter -->
              <div class="filter-group">
                <label class="filter-label">Comunas</label>
                <div class="multiselect-wrapper">
                  <multiselect
                    v-model="comunas_en_ordenes_seleccionadas"
                    :options="comunas_en_ordenes"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Seleccionar comunas"
                    label="Nombre"
                    track-by="id"
                    :preselect-first="true"
                    selectedLabel="Seleccionado"
                    selectLabel="Pulsar para seleccionar"
                    deselectLabel="Pulsar para remover"
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- Chart Type Selector -->
          <div class="chart-selector-section">
            <div class="chart-selector-container">
              <div class="chart-selector-header">
                <h3>Análisis de Densidad</h3>
                <div class="chart-type-dropdown">
                  <button 
                    class="dropdown-trigger"
                    @click="viendo_menu = !viendo_menu"
                  >
                    <span>{{ grafico_densidad == 0 ? 'Densidad de atención' : 'Densidad de compra' }}</span>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <polyline points="6,9 12,15 18,9"></polyline>
                    </svg>
                  </button>
                  
                  <div v-if="viendo_menu" class="dropdown-menu">
                    <button 
                      class="dropdown-item"
                      @click="grafico_densidad = 0; viendo_menu = false;"
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M3 3v5h5"></path>
                        <path d="M6 17l4-4 4 4 6-6"></path>
                        <path d="M18 7v5h5"></path>
                      </svg>
                      Densidad de atención
                    </button>
                    <button 
                      class="dropdown-item"
                      @click="grafico_densidad = 1; viendo_menu = false;"
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="M16 8l-4 4 4 4"></path>
                        <path d="M8 12h8"></path>
                      </svg>
                      Densidad de compra
                    </button>
                  </div>
                </div>
              </div>

              <div class="chart-container">
                <WeekDensityChart
                  v-show="grafico_densidad == 0"
                  :ordenes="ordenes_filtradas"
                  :bgColor="'rgb(20, 134, 231)'"
                />
                <WeekDensityOrderChart
                  v-show="grafico_densidad == 1"
                  :ordenes="ordenes_filtradas"
                  :bgColor="'red'"
                />
              </div>
            </div>
          </div>

          <!-- Statistics Cards -->
          <div class="statistics-section">
            <div class="statistics-header">
              <div class="stats-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                  <path d="M9 9h6v6H9z"></path>
                </svg>
              </div>
              <h3>Estadísticas Generales</h3>
            </div>

            <div class="stats-grid">
              <div class="stat-card revenue">
                <div class="stat-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <line x1="12" y1="1" x2="12" y2="23"></line>
                    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                  </svg>
                </div>
                <div class="stat-content">
                  <div class="stat-label">Total Ingresos</div>
                  <div class="stat-value">${{ Intl.NumberFormat('de-DE').format(ordenes_filtradas.filter(z=>{return z.estado != 0}).reduce((a, b)=>{ return (a+b.monto || 0)}, 0)) }}</div>
                </div>
              </div>

              <div class="stat-card orders">
                <div class="stat-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <polyline points="14,2 14,8 20,8"></polyline>
                    <line x1="16" y1="13" x2="8" y2="13"></line>
                    <line x1="16" y1="17" x2="8" y2="17"></line>
                    <polyline points="10,9 9,9 8,9"></polyline>
                  </svg>
                </div>
                <div class="stat-content">
                  <div class="stat-label">Órdenes Totales</div>
                  <div class="stat-value">{{ ordenes_filtradas.length }}</div>
                </div>
              </div>

              <div class="stat-card patients">
                <div class="stat-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                </div>
                <div class="stat-content">
                  <div class="stat-label">Pacientes</div>
                  <div class="stat-value">{{ ordenes_filtradas.reduce((a, b)=>{return (a +b.clientes.length || 0)}, 0) }}</div>
                </div>
              </div>

              <div class="stat-card cancelled">
                <div class="stat-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="15" y1="9" x2="9" y2="15"></line>
                    <line x1="9" y1="9" x2="15" y2="15"></line>
                  </svg>
                </div>
                <div class="stat-content">
                  <div class="stat-label">Órdenes Canceladas</div>
                  <div class="stat-value">{{ ordenes_filtradas.filter(x=>{return x.estado == 0}).length }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Quantity Charts Section -->
          <div class="charts-section">
            <div class="section-header">
              <div class="section-icon quantity">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path>
                  <path d="M22 12A10 10 0 0 0 12 2v10z"></path>
                </svg>
              </div>
              <h3>Gráficos por Cantidad</h3>
            </div>

            <div class="charts-grid">
              <div class="chart-card">
                <div class="chart-header">
                  <h4>Órdenes Pagadas / No Pagadas</h4>
                </div>
                <div class="chart-content">
                  <pie-chart
                    v-if="ordenes.length != 0"
                    :key="key"
                    :height="300"
                    :data="graficoPagadoNoPagado"
                    :options="chartOptions"
                  />
                  <div v-if="ordenes.length == 0" class="no-data">
                    <div class="no-data-icon">
                      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                        <path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path>
                        <path d="M22 12A10 10 0 0 0 12 2v10z"></path>
                      </svg>
                    </div>
                    <p>No hay órdenes para el intervalo de tiempo</p>
                  </div>
                </div>
              </div>

              <div class="chart-card">
                <div class="chart-header">
                  <h4>Órdenes por Estados</h4>
                </div>
                <div class="chart-content">
                  <pie-chart
                    v-if="ordenes.length != 0"
                    :key="key"
                    :height="300"
                    :data="graficoEstados"
                    :options="chartOptions"
                  />
                  <div v-if="ordenes.length == 0" class="no-data">
                    <div class="no-data-icon">
                      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                        <path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path>
                        <path d="M22 12A10 10 0 0 0 12 2v10z"></path>
                      </svg>
                    </div>
                    <p>No hay órdenes para el intervalo de tiempo</p>
                  </div>
                </div>
              </div>

              <div class="chart-card">
                <div class="chart-header">
                  <h4>Exámenes por Categoría</h4>
                </div>
                <div class="chart-content">
                  <pie-chart
                    v-if="ordenes.length != 0"
                    :key="key"
                    :height="300"
                    :data="graficoCategorias"
                    :options="chartOptions"
                  />
                  <div v-if="ordenes.length == 0" class="no-data">
                    <div class="no-data-icon">
                      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                        <path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path>
                        <path d="M22 12A10 10 0 0 0 12 2v10z"></path>
                      </svg>
                    </div>
                    <p>No hay órdenes para el intervalo de tiempo</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Sales Charts Section -->
          <div class="charts-section">
            <div class="section-header">
              <div class="section-icon sales">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <line x1="12" y1="1" x2="12" y2="23"></line>
                  <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                </svg>
              </div>
              <h3>Gráficos por Ventas</h3>
            </div>

            <div class="charts-grid">
              <div class="chart-card">
                <div class="chart-header">
                  <h4>Venta Órdenes Pagadas / No Pagadas</h4>
                </div>
                <div class="chart-content">
                  <pie-chart
                    v-if="ordenes.length != 0"
                    :key="key"
                    :height="300"
                    :data="graficoPagadoNoPagadoVenta"
                    :options="chartOptions"
                  />
                  <div v-if="ordenes.length == 0" class="no-data">
                    <div class="no-data-icon">
                      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                        <line x1="12" y1="1" x2="12" y2="23"></line>
                        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                      </svg>
                    </div>
                    <p>No hay órdenes para el intervalo de tiempo</p>
                  </div>
                </div>
              </div>

              <div class="chart-card">
                <div class="chart-header">
                  <h4>Ventas por Comuna</h4>
                </div>
                <div class="chart-content">
                  <pie-chart
                    v-if="ordenes.length != 0"
                    :key="key"
                    :height="300"
                    :data="graficoComunas"
                    :options="chartOptions"
                  />
                  <div v-if="ordenes.length == 0" class="no-data">
                    <div class="no-data-icon">
                      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                        <line x1="12" y1="1" x2="12" y2="23"></line>
                        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                      </svg>
                    </div>
                    <p>No hay órdenes para el intervalo de tiempo</p>
                  </div>
                </div>
              </div>

              <div class="chart-card">
                <div class="chart-header">
                  <h4>Ventas por Categoría</h4>
                </div>
                <div class="chart-content">
                  <pie-chart
                    v-if="ordenes.length != 0"
                    :key="key"
                    :height="300"
                    :data="graficoCategoriasVenta"
                    :options="chartOptions"
                  />
                  <div v-if="ordenes.length == 0" class="no-data">
                    <div class="no-data-icon">
                      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                        <line x1="12" y1="1" x2="12" y2="23"></line>
                        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                      </svg>
                    </div>
                    <p>No hay órdenes para el intervalo de tiempo</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios';
import {mapGetters, mapActions} from 'vuex';
import WeekDensityChart from "./WeekDensityChart.vue";
import WeekDensityOrderChart from "./WeekDensityOrderChart.vue";
import PieChart from "./PieChart.vue";
import Multiselect from 'vue-multiselect'
import TopNavClean from './TopNavClean.vue';
import SideNav from '@/components/SideNav.vue';

export default {
  name: 'Reportes',
  components:{
    WeekDensityOrderChart,
    WeekDensityChart,
    TopNavClean,
    PieChart,
    Multiselect,
    SideNav
  },
  data() {
    return {
      viendo_menu:false,
      grafico_densidad:0,
      email:'',
      nombre:'',
      apellido:'',
      rut:'',

      dt_dia:'',
      dt_dia2:'',

      desde:{d:0, m:0, a:0},
      hasta:{d:0, m:0, a:0},

      ordenes:[],
      ordenes_calculated:[],

      puede_seleccionar_prestadores:false,
      prestadores_habilitados:[],
      prestadores_seleccionados:[],

      comunas_en_ordenes:[],
      comunas_en_ordenes_seleccionadas:[],


      id_orden:0,

      popup: false,
      mouseX:0,
      mouseY:0,

      resultado:'',
      estados : ['Anulado', 'Citado',  'Confirmado', 'Atendido', 'No Atendido'],

      key:0,
      keyMain:0,
      
      chartOptions: {
        responsive:true,
        hoverBorderWidth: 20,
        title: {
          display: false,
          text: 'Actividad en la próxima'
        },
                pieceLabel: {
            mode: 'value'
        },
        legend:{display:true, position:'right'},

      },


      optionsLinea: {
            maintainAspectRatio: false,
            height: 70,
            responsive: true,
            title:{
                display: false,
                text: "Chart.js Time Scale"
            },
            scales:{
                xAxes: [{
                    type: "time",
                    time: {unit: 'day', displayFormats: {day: 'MMM DD' }
                },
                scaleLabel: {
                    display: true,
                    labelString: 'Día'
                }
                }],
                yAxes: [{
                  ticks: {
                    beginAtZero: true,
                  },
                    scaleLabel: {
                        display:     true,
                        labelString: 'Monto'
                    }
                }]
            }
      },

      

    }
  },
  methods:{
    ...mapActions(['loginAdmin']),

    descargarCSV(){
      axios({
        url: window.hostname+'/api/admin/exportar_ordenes',
        method: 'POST',
        responseType: 'blob',
        data: {
          dia:this.desde.d, mes:this.desde.m, año:this.desde.a,
          dia2:this.hasta.d, mes2:this.hasta.m, año2:this.hasta.a
        }
      })
      .then( (response) =>  {
        console.log(response);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'exportar.xlsx'); 
        document.body.appendChild(link);
        link.click();          
      })
      .catch(e=>{
        console.log(e);
      })

    },

    groupBy (xs, key) {
      return xs.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },

    cambiarEstado(e){
        axios.post(window.hostname+'/api/admin/cambiarEstado', 
        {orden_id:this.id_orden, estado_id:e})
        .then(response => 
        {
          this.get_ordenes()
          this.popup = false;
        })

        .catch(e=>{
          if (e.response.data.message)
            this.resultado = e.response.data.message           
        })

    },

    descargarCSVPago(){
        axios({
          url: window.hostname+'/api/admin/get_reporte',
          method: 'POST',
          responseType: 'blob',
          data: {
            dia:this.desde.d, mes:this.desde.m, año:this.desde.a,
            dia2:this.hasta.d, mes2:this.hasta.m, año2:this.hasta.a
          }
        })
        .then(response =>{
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'exportar_pago.csv'); 
            document.body.appendChild(link);
            link.click();          
        })
        .catch( (e) =>{
          console.log(e)
        })

    },

    marcar_pagado(e){
        axios.post(window.hostname+'/api/admin/marcar_pagado', 
        {orden_id:this.id_orden})
        .then(response => 
        {
          this.get_ordenes()
          this.popup = false;
        })

        .catch(e=>{
          if (e.response.data.message)
            this.resultado = e.response.data.message           
        })

    },
    timeConvert(n) {
      var num = n;
      var hours = (num / 60);
      var rhours = Math.floor(hours);
      var minutes = (hours - rhours) * 60;
      var rminutes = Math.round(minutes);
      return (rhours < 10 ? '0':'')+rhours + ":"+ (rminutes < 10 ? '0':'') + rminutes + "";
    },
      mouseEnter(event, order_id) {

          this.popup = true;
          this.id_orden = order_id
          //this.$el.addEventListener('mousemove', this.mouseMove, false);
          this.mouseX = event.clientX;
          this.mouseY = event.clientY;
      },
      mouseLeave(event) {
        if (!(event.clientX >= this.mouseX && event.clientY >= this.mouseY))
        {

          this.popup = false;
        }

      },
    close (e){
      /*Si clickeo (e.target) fuera de este componente (this.$el), se cierra*/
      if (!(e.target.classList.contains('dontClose')))
        this.showinFuncionesList = false
    },
    get_ordenes(){      
      if (this.desde.a != 0 && this.hasta.a != 0)
      {
        axios.post(window.hostname+'/api/admin/get_reporte', {
          dia:this.desde.d, mes:this.desde.m, año:this.desde.a,
          dia2:this.hasta.d, mes2:this.hasta.m, año2:this.hasta.a
        })
          .then((response) => {
            this.prestadores_habilitados = response.data.prestadores_habilitados;
            if (this.prestadores_seleccionados.length == 0) {
              this.prestadores_seleccionados = this.prestadores_habilitados;
            }

            this.ordenes = response.data.ordenes;
            if (this.prestador.id in [0, 1]) {
              this.puede_seleccionar_prestadores = true;
              this.ordenes = this.ordenes.filter((orden) => {
                return this.prestadores_seleccionados.some((prestador) => {
                  return prestador.prestador_id == orden.prestador_id;
                });
              });
            } else {
              this.puede_seleccionar_prestadores = false;
              this.ordenes = this.ordenes.filter(orden => orden.orden_propia == true)
            }
            
            function compare(a, b) {
              let da = new Date(a.fecha.a, a.fecha.m, a.fecha.d)
              let db = new Date(b.fecha.a, b.fecha.m, b.fecha.d)
              if ((a.urgente && a.estado == 1)  && !(b.urgente && b.estado == 1)){
                return -1                
              } else if (!(a.urgente && a.estado == 1) && (b.urgente && b.estado == 1)){
                return 1
              } else if(da > db){
                return 1
              } else if (da < db){
                return -1
              } else {
                return 0
              }
            }

            this.ordenes_calculated = []
            var ins = {}
            var hoy = new Date();
            var dia = new Date();
            var comunas_en_ordenes = []
            var comunas_en_ordenes_ids = []

            for (var i = 0; i < this.ordenes.length; i++){
              ins = this.ordenes[i]
              dia = new Date(ins.fecha.a, ins.fecha.m-1, ins.fecha.d)
              if ((((dia.getTime()+(1000 * 60 * ins.desde))-hoy.getTime())/(1000 * 60 * 60)) < 2*24)
                ins.urgente = true;
              else
                ins.urgente = false;
              if(!comunas_en_ordenes_ids.includes(ins.comuna_id)){
                comunas_en_ordenes_ids.push(ins.comuna_id);
                comunas_en_ordenes.push(this.comunas.find(x=>{return x.id == ins.comuna_id}));
              }
              this.ordenes_calculated.push(ins)
            }
            this.comunas_en_ordenes = comunas_en_ordenes;
            this.comunas_en_ordenes_seleccionadas = comunas_en_ordenes;
            this.ordenes_calculated.sort(compare)
          })
          .catch((e) => {
            console.log("error:", e)        
          }
        )
      }
    }

  },
  computed:{
    ...mapGetters(['comunas', 'regiones', 'categorias', 'prestaciones', 'tipos', 'admin_datos', 'examenes', 'prestador']),
      ordenes_filtradas(){
        return this.ordenes.filter(
          orden=>
          {
            return this.comunas_en_ordenes_seleccionadas.some((comuna) => {
                  return comuna.id == orden.comuna_id;
                }) && 
            this.prestadores_seleccionados.some((prestador) => {
                  return prestador.prestador_id == orden.prestador_id;
                })})
      },
      graficoComunas(){
      var ret = this.groupBy(this.ordenes, 'comuna_id')

      let keys = Object.keys(ret)
      var labs = []
      var data = []
      for(var k = 0; k< keys.length; k++){
        labs.push(this.comunas.filter(x=>{return x.id == keys[k]})[0].Nombre)
        data.push(ret[keys[k]].reduce((a, b)=>{return (a+b.monto || 0) }, 0))
      }
    
     
      let graph = {
        hoverBackgroundColor: "red",
        hoverBorderWidth: 10,
        labels: labs,
        datasets: [
          {
            label: "Data One",
                        backgroundColor: [
      'rgba(255, 99, 132, 0.8)',
      'rgba(255, 159, 64, 0.8)',
      'rgba(255, 205, 86, 0.8)',
      'rgba(75, 192, 192, 0.8)',
      'rgba(54, 162, 235, 0.8)',
      'rgba(153, 102, 255, 0.8)',
      'rgba(201, 203, 207, 0.8)'
    ].reverse(),
            data: data
          }
        ]
      }

      return graph;
    },
      graficoCategoriasVenta(){
      var labels = []
      var data = []
      for(var i = 0; i < this.categorias.length; i++){
        data.push(
          this.ordenes.reduce((a, b)=>{
                return (a+b.examenes.filter(z=>{
                  return this.examenes.filter(m=>{return m.id == z.examen_id}).length > 0 ? (this.examenes.filter(m=>{return m.id == z.examen_id})[0].categoria_id == this.categorias[i].id) : false}).reduce((c, d)=>{return c+d.precio || 0}, 0) || 0) }, 0))
        labels.push(this.categorias[i].nombre)
      }
    
     
      let graph = {
        hoverBackgroundColor: "red",
        hoverBorderWidth: 10,
        labels: labels,
        datasets: [
          {
            label: "Data One",
                        backgroundColor: [
      'rgba(255, 99, 132, 0.8)',
      'rgba(255, 159, 64, 0.8)',
      'rgba(255, 205, 86, 0.8)',
      'rgba(75, 192, 192, 0.8)',
      'rgba(54, 162, 235, 0.8)',
      'rgba(153, 102, 255, 0.8)',
      'rgba(201, 203, 207, 0.8)'
    ].reverse(),
            data: data
          }
        ]
      }

      return graph;
    },
      graficoCategorias(){
      var labels = []
      var data = []
      for(var i = 0; i < this.categorias.length; i++){
        data.push(this.ordenes.reduce((a, b)=>{return (a+b.examenes.filter(z=>{return this.examenes.filter(m=>{return m.id == z.examen_id}).length > 0 ? this.examenes.filter(m=>{return m.id == z.examen_id})[0].categoria_id == this.categorias[i].id : false}).length || 0) }, 0))
        labels.push(this.categorias[i].nombre)
      }
    
     
      let graph = {
        hoverBackgroundColor: "red",
        hoverBorderWidth: 10,
        labels: labels,
        datasets: [
          {
            label: "Data One",
                        backgroundColor: [
      'rgba(255, 99, 132, 0.8)',
      'rgba(255, 159, 64, 0.8)',
      'rgba(255, 205, 86, 0.8)',
      'rgba(75, 192, 192, 0.8)',
      'rgba(54, 162, 235, 0.8)',
      'rgba(153, 102, 255, 0.8)',
      'rgba(201, 203, 207, 0.8)'
    ].reverse(),
            data: data
          }
        ]
      }

      return graph;
    },
      graficoEstados(){
      let nCanceladas = this.ordenes.filter(x=>{return x.pagado == 0}).length
      let nAgendadas = this.ordenes.filter(x=>{return x.pagado == 1}).length

      let labels = this.estados
      var data = []
      for(var i = 0; i < this.estados.length; i++){
        data.push(this.ordenes.filter(x=>{return x.estado == i}).length)

      }          
     
      let graph = {
        hoverBackgroundColor: "red",
        hoverBorderWidth: 10,
        labels: labels,
        datasets: [
          {
            label: "Data One",
                        backgroundColor: [
      'rgba(255, 99, 132, 0.8)',
      'rgba(255, 159, 64, 0.8)',
      'rgba(255, 205, 86, 0.8)',
      'rgba(75, 192, 192, 0.8)',
      'rgba(54, 162, 235, 0.8)',
      'rgba(153, 102, 255, 0.8)',
      'rgba(201, 203, 207, 0.8)'
    ],
            data: data
          }
        ]
      }

      return graph;
    },
    
      graficoPagadoNoPagadoVenta(){
      let nCanceladas = this.ordenes.filter(x=>{return x.pagado == 0}).reduce((a,b) =>{return a+b.monto || 0 }, 0)
      let nAgendadas = this.ordenes.filter(x=>{return x.pagado == 1}).reduce((a,b) =>{return a+b.monto || 0 }, 0)

      let labels = ['Pagadas', 'No Pagadas']


          
     
      let graph = {
        hoverBackgroundColor: "red",
        hoverBorderWidth: 10,
        labels: labels,
        datasets: [
          {
            label: "Data One",
            backgroundColor: ["#3D9970", "#FF4136"],
            data: [nAgendadas, nCanceladas]
          }
        ]
      }

      return graph;
    },
      graficoPagadoNoPagado(){
      let nCanceladas = this.ordenes.filter(x=>{return x.pagado == 0}).length
      let nAgendadas = this.ordenes.filter(x=>{return x.pagado == 1}).length

      let labels = ['Pagadas', 'No Pagadas']


          
     
      let graph = {
        hoverBackgroundColor: "red",
        hoverBorderWidth: 10,
        labels: labels,
        datasets: [
          {
            label: "Data One",
            backgroundColor: ["#3D9970", "#FF4136"],
            data: [nAgendadas, nCanceladas]
          }
        ]
      }

      return graph;
    },
    
    graficoLineaSumaPagos(){

      var ret = this.groupBy(this.ordenes, 'fecha_dt')
      var ret_fecha_creado = this.groupBy(this.ordenes, 'fecha_creado_dt')
      let labels1 = []
      let labels2 = []
      let ventasProgramadasTotal = []
      let fecha;
      let desde_ = new Date(this.desde.a, this.desde.m-1, this.desde.d)
      let hasta_ = new Date(this.hasta.a, this.hasta.m-1, this.hasta.d)
      for(var itDia = new Date(desde_.getFullYear(), desde_.getMonth(), desde_.getDate()); itDia <= hasta_; itDia.setDate(itDia.getDate() + 1)){
        fecha = itDia.toLocaleDateString("en-US", {year:"numeric", month:'2-digit', day:'2-digit'})
        if (ret.hasOwnProperty(fecha)) {
          labels1.push({x:fecha, y:ret[fecha].filter(x=>{return x.estado != 0}).reduce((a, b)=>{return  (a+b.monto || 0) }, 0)})
          labels2.push({x:fecha, y:ret[fecha].filter(x=>{return x.pagado == 1 && x.estado != 0}).reduce((a, b)=>{return  (a+b.monto || 0) }, 0)})
        } else {
          labels1.push({x:fecha, y:0})
          labels2.push({x:fecha, y:0})
        }
        if (ret_fecha_creado.hasOwnProperty(fecha)) {
          ventasProgramadasTotal.push({x:fecha, y:ret_fecha_creado[fecha].reduce((a, b)=>{return  (a+b.monto || 0) }, 0)})
        } else {
          ventasProgramadasTotal.push({x:fecha, y:0})
        }
      }
      let graph = {          
        datasets: [
          {
            label: "Ingreso diario total", 
            data: labels1,
            fill: false,
            borderColor: 'rgba(255, 10, 13, 0.5)',
            backgroundColor: "rgba(255, 10, 13, 0.2)"
          },
          {
            label: "Ingreso diario cobrado", 
            data: labels2,
            fill: false,
            backgroundColor: 'rgba(46, 204, 64, 0.2)',
            borderColor: 'rgba(46, 204, 64, 0.5)'
          },
          {
            label: "Ventas programadas", 
            data: ventasProgramadasTotal,
            fill: false,
            backgroundColor: 'rgba(246, 237, 116, 0.2)',
            borderColor: 'rgba(246, 237, 116, 0.5)'
          }
        ]
      }

      return graph;
    },

  },
  watch:{
    dt_dia(val){

        var datos = val.split('-')
        this.desde = {a:Number(datos[0]), m:Number(datos[1]), d:Number(datos[2])}
        this.get_ordenes()
      
    },
    dt_dia2(val){
        var datos = val.split('-')
        this.hasta = {a:Number(datos[0]), m:Number(datos[1]), d:Number(datos[2])}
        this.get_ordenes()
      
    },
    ordenes(){
      this.key +=1; 
    },
    prestadores_seleccionados: function (val) {
      this.get_ordenes();
    },

  },
  mounted() {
    document.addEventListener('click', this.close);
    var hoy = new Date();
    this.dt_dia = hoy.toISOString().split('T')[0];
    hoy.setDate(hoy.getDate() + 7);
    this.dt_dia2 = hoy.toISOString().split('T')[0];
  },
  beforeUnmount () {
    document.removeEventListener('click',this.close)
  }

}
</script>

<style scoped>
/* Base Styles - Notion-inspired with medical touches */
.medical-reports-wrapper {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
}

.column-left {
  position: fixed;
  left: 0;
  top: 0;
  width: 280px;
  height: 100vh;
  z-index: 1000;
}

.column-right {
  background-color: var(--background-primary);
  padding-top: 0px;
  padding-left: 275px;
  width: 100%;
  min-height: 100vh;
}

.main-container {
  padding: 0;
}

.reports-content {
  padding: 2rem;
  max-width: 1400px;
  margin: 0 auto;
}

/* Page Header */
.page-header {
  background: white;
  border-radius: 16px;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 2rem;
}

.title-section {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.page-icon {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.page-title {
  font-size: 2rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 0.5rem;
  letter-spacing: -0.025em;
}

.page-subtitle {
  font-size: 1.125rem;
  color: #64748b;
  margin: 0;
  font-weight: 400;
}

.header-actions {
  display: flex;
  align-items: center;
}

.download-btn {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(16, 185, 129, 0.2);
}

.download-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(16, 185, 129, 0.3);
}

/* Report Container */
.report-container {
  background: white;
  border-radius: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;
  overflow: hidden;
}

/* Filters Section */
.filters-section {
  padding: 2rem;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.filters-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.filter-icon {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #8b5cf6, #7c3aed);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.filters-header h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
}

.filters-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.filter-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: #64748b;
}

/* Date Range */
.date-range-container {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.date-input-wrapper {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  padding: 0.75rem;
  transition: all 0.2s ease;
}

.date-input-wrapper:focus-within {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.date-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #64748b;
  white-space: nowrap;
}

.date-input {
  border: none;
  outline: none;
  background: transparent;
  font-size: 0.875rem;
  color: #1e293b;
  font-weight: 500;
}

.date-separator {
  color: #94a3b8;
  display: flex;
  align-items: center;
}

/* Multiselect Wrapper */
.multiselect-wrapper {
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.multiselect-wrapper:focus-within {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* Chart Selector Section */
.chart-selector-section {
  padding: 2rem;
  border-bottom: 1px solid #e2e8f0;
}

.chart-selector-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.chart-selector-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.chart-selector-header h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
}

.chart-type-dropdown {
  position: relative;
}

.dropdown-trigger {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #1e293b;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 200px;
}

.dropdown-trigger:hover {
  border-color: #cbd5e1;
  background-color: #f8fafc;
}

.dropdown-menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  z-index: 1000;
  min-width: 200px;
  overflow: hidden;
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  padding: 0.75rem 1rem;
  background: none;
  border: none;
  text-align: left;
  font-size: 0.875rem;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s ease;
}

.dropdown-item:hover {
  background-color: #f8fafc;
  color: #1e293b;
}

.chart-container {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 1.5rem;
}

/* Statistics Section */
.statistics-section {
  padding: 2rem;
  border-bottom: 1px solid #e2e8f0;
}

.statistics-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;
}

.stats-icon {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #f59e0b, #d97706);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.statistics-header h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
}

.stat-card {
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.stat-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, var(--card-color), var(--card-color-light));
}

.stat-card.revenue {
  --card-color: #0074d9;
  --card-color-light: #4dabf7;
}

.stat-card.orders {
  --card-color: #ff851b;
  --card-color-light: #ffa94d;
}

.stat-card.patients {
  --card-color: #39cccc;
  --card-color-light: #66d9ef;
}

.stat-card.cancelled {
  --card-color: #ff4136;
  --card-color-light: #ff6b6b;
}

.stat-card:hover {
  border-color: var(--card-color);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07), 0 1px 3px rgba(0, 0, 0, 0.06);
  transform: translateY(-2px);
}

.stat-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  background: var(--card-color);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.stat-content {
  flex: 1;
}

.stat-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #64748b;
  margin-bottom: 0.25rem;
}

.stat-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.2;
}

/* Charts Section */
.charts-section {
  padding: 2rem;
}

.charts-section:not(:last-child) {
  border-bottom: 1px solid #e2e8f0;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;
}

.section-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.section-icon.quantity {
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
}

.section-icon.sales {
  background: linear-gradient(135deg, #10b981, #059669);
}

.section-header h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
}

.charts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 2rem;
}

.chart-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.chart-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07), 0 1px 3px rgba(0, 0, 0, 0.06);
  transform: translateY(-2px);
}

.chart-header {
  background: white;
  padding: 1.5rem;
  border-bottom: 1px solid #e2e8f0;
}

.chart-header h4 {
  font-size: 1rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
}

.chart-content {
  padding: 1.5rem;
  background: white;
}

/* No Data State */
.no-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 1rem;
  text-align: center;
}

.no-data-icon {
  color: #94a3b8;
  margin-bottom: 1rem;
}

.no-data p {
  color: #64748b;
  font-size: 0.875rem;
  margin: 0;
  font-weight: 500;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .column-right {
    margin-left: 0;
  }

  .reports-content {
    padding: 1rem;
  }

  .header-content {
    flex-direction: column;
    align-items: stretch;
    gap: 1.5rem;
  }

  .filters-grid {
    grid-template-columns: 1fr;
  }

  .stats-grid {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  }

  .charts-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .reports-content {
    padding: 0.5rem;
  }

  .page-header {
    padding: 1.5rem;
  }

  .title-section {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }

  .page-icon {
    width: 48px;
    height: 48px;
  }

  .page-title {
    font-size: 1.5rem;
  }

  .page-subtitle {
    font-size: 1rem;
  }

  .filters-section,
  .chart-selector-section,
  .statistics-section,
  .charts-section {
    padding: 1.5rem;
  }

  .date-range-container {
    flex-direction: column;
    align-items: stretch;
  }

  .chart-selector-header {
    flex-direction: column;
    align-items: stretch;
    gap: 1rem;
  }

  .stats-grid {
    grid-template-columns: 1fr;
  }

  .stat-card {
    padding: 1rem;
  }

  .stat-value {
    font-size: 1.25rem;
  }

  .charts-grid {
    grid-template-columns: 1fr;
  }

  .chart-card {
    min-width: 0;
  }
}

@media (max-width: 480px) {
  .reports-content {
    padding: 0.25rem;
  }

  .page-header {
    padding: 1rem;
  }

  .filters-section,
  .chart-selector-section,
  .statistics-section,
  .charts-section {
    padding: 1rem;
  }

  .chart-header,
  .chart-content {
    padding: 1rem;
  }

  .stat-card {
    flex-direction: column;
    text-align: center;
    gap: 0.75rem;
  }

  .download-btn {
    padding: 0.75rem 1.5rem;
    font-size: 0.875rem;
  }

  .dropdown-trigger {
    min-width: 150px;
    font-size: 0.75rem;
  }
}

/* Focus States */
.download-btn:focus,
.date-input:focus,
.dropdown-trigger:focus,
.dropdown-item:focus {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}

/* High Contrast Mode */
@media (prefers-contrast: high) {
  .report-container,
  .stat-card,
  .chart-card {
    border-width: 2px;
  }

  .date-input-wrapper,
  .multiselect-wrapper,
  .dropdown-trigger {
    border-width: 2px;
  }
}

/* Reduced Motion */
@media (prefers-reduced-motion: reduce) {
  .download-btn,
  .date-input-wrapper,
  .multiselect-wrapper,
  .dropdown-trigger,
  .dropdown-item,
  .stat-card,
  .chart-card {
    transition: none;
  }
}

/* Dark mode support (if needed) */
@media (prefers-color-scheme: dark) {
  .medical-reports-wrapper {
    background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
  }

  .page-header,
  .report-container,
  .stat-card,
  .chart-card {
    background: #1e293b;
    border-color: #334155;
  }

  .filters-section,
  .chart-container {
    background: #0f172a;
    border-bottom-color: #334155;
  }

  .page-title,
  .filters-header h3,
  .chart-selector-header h3,
  .statistics-header h3,
  .section-header h3,
  .chart-header h4,
  .stat-value {
    color: #e2e8f0;
  }

  .page-subtitle,
  .filter-label,
  .stat-label,
  .no-data p {
    color: #94a3b8;
  }

  .date-input-wrapper,
  .multiselect-wrapper,
  .dropdown-trigger,
  .dropdown-menu {
    background: #1e293b;
    border-color: #334155;
  }

  .date-input {
    color: #e2e8f0;
  }

  .dropdown-item {
    color: #94a3b8;
  }

  .dropdown-item:hover {
    background: #0f172a;
    color: #e2e8f0;
  }

  .chart-header,
  .chart-content {
    background: #1e293b;
    border-bottom-color: #334155;
  }
}

@media (max-width: 1200px) {
  .column-right {
    padding-left: 0px;
  }

  .professional-card {
    border-color: #000;
  }
  
  .tag {
    border-width: 2px;
  }
  
  .action-btn {
    border: 1px solid currentColor;
  }
}
</style>